(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-about"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annber-about-reveal')) {
    class AnnberAboutReveal extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-annber-reveal]');
        if (!items.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || this.hasAttribute('data-shopify-visual-preview')) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.classList.add('is-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
        );

        items.forEach((item) => observer.observe(item));
      }
    }

    customElements.define('annber-about-reveal', AnnberAboutReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annber-collection-reveal')) {
    class AnnberCollectionReveal extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-annber-reveal]');
        if (!items.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || this.hasAttribute('data-shopify-visual-preview')) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.classList.add('is-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
        );

        items.forEach((item) => observer.observe(item));
      }
    }

    customElements.define('annber-collection-reveal', AnnberCollectionReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annber-footer')) {
    class AnnberFooter extends HTMLElement {
      connectedCallback() {
        this.collapsible = this.dataset.collapsible === 'true';
        this.media = window.matchMedia('(max-width: 749px)');
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.onToggle = this.onToggle.bind(this);
        this.onMedia = this.onMedia.bind(this);

        if (!this.collapsible) return;

        this.items.forEach((item) => {
          const button = item.querySelector('.annber-footer__toggle');
          if (button) button.addEventListener('click', this.onToggle);
        });

        this.media.addEventListener('change', this.onMedia);
        window.addEventListener('resize', this.onMedia);
        this.sync();
      }

      disconnectedCallback() {
        if (!this.collapsible) return;
        this.media.removeEventListener('change', this.onMedia);
        window.removeEventListener('resize', this.onMedia);
        this.items.forEach((item) => {
          const button = item.querySelector('.annber-footer__toggle');
          if (button) button.removeEventListener('click', this.onToggle);
        });
      }

      isMobile() {
        return this.media.matches;
      }

      sync() {
        const mobile = this.isMobile();
        this.items.forEach((item) => {
          const button = item.querySelector('.annber-footer__toggle');
          const panel = item.querySelector('.annber-footer__panel');
          if (!button || !panel) return;

          if (!mobile) {
            button.setAttribute('aria-expanded', 'true');
            button.setAttribute('tabindex', '-1');
            panel.classList.add('is-open');
            panel.inert = false;
            return;
          }

          button.removeAttribute('tabindex');
          const expanded = button.getAttribute('aria-expanded') === 'true' && button.hasAttribute('data-user-toggled');
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          panel.classList.toggle('is-open', expanded);
          panel.inert = !expanded;
        });
      }

      onMedia() {
        if (!this.isMobile()) {
          this.items.forEach((item) => {
            const button = item.querySelector('.annber-footer__toggle');
            if (button) button.removeAttribute('data-user-toggled');
          });
        }
        this.sync();
      }

      onToggle(event) {
        if (!this.isMobile()) return;
        const button = event.currentTarget;
        const item = button.closest('[data-accordion-item]');
        const panel = item ? item.querySelector('.annber-footer__panel') : null;
        if (!panel) return;

        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        button.setAttribute('data-user-toggled', 'true');
        panel.classList.toggle('is-open', willOpen);
        panel.inert = !willOpen;
      }
    }

    customElements.define('annber-footer', AnnberFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annber-hero-slideshow')) {
    class AnnberHeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-annber-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-annber-dot]'));
        this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (this.index < 0) this.index = 0;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
        this.speed = Number(this.dataset.speed) || 6000;
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length <= 1) return;

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index, true));
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.goTo(this.index + 1, true);
          if (event.key === 'ArrowLeft') this.goTo(this.index - 1, true);
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (this.autoplayEnabled && !this.reducedMotion) this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      onBlockSelect = (event) => {
        const slide = event.target.closest('[data-annber-slide]');
        if (!slide || !this.contains(slide)) return;
        this.stop();
        this.goTo(this.slides.indexOf(slide), true);
      };

      onBlockDeselect = (event) => {
        const slide = event.target.closest('[data-annber-slide]');
        if (!slide || !this.contains(slide)) return;
        if (this.autoplayEnabled && !this.reducedMotion) this.start();
      };

      goTo(nextIndex, user = false) {
        if (!this.slides.length) return;
        const total = this.slides.length;
        const index = ((nextIndex % total) + total) % total;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.index = index;
        if (user && this.autoplayEnabled && !this.reducedMotion) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplayEnabled || this.reducedMotion || this.slides.length <= 1) return;
        this.timer = window.setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('annber-hero-slideshow', AnnberHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-moods"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annber-moods')) {
    class AnnberMoods extends HTMLElement {
      connectedCallback() {
        this.setupReveal();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      setupReveal() {
        const items = this.querySelectorAll('[data-annber-reveal]');
        if (!items.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || this.hasAttribute('data-shopify-visual-preview')) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.classList.add('is-ready');

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
        );

        items.forEach((item) => this.observer.observe(item));
      }
    }

    customElements.define('annber-moods', AnnberMoods);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-promise"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('annber-promise-reveal')) {
    class AnnberPromiseReveal extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('[data-annber-reveal]');
        if (!items.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || this.hasAttribute('data-shopify-visual-preview')) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.classList.add('is-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
        );

        items.forEach((item) => observer.observe(item));
      }
    }

    customElements.define('annber-promise-reveal', AnnberPromiseReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
